import { axiosApi } from "../api/axiosClient";
import { BlogType } from "../Types/types";

export const handleGetBlogs = async (
  currentPage: number,
  limit: number
): Promise<{
  data: BlogType[] | null;
  status: number;
  meta: any;
}> => {
  try {
    const response = await axiosApi.get("/john-blogs", {
      params: {
        populate: "image",
        sort : "publishedAt:desc",
        pagination: {
          page: currentPage,
          pageSize: limit,
        },
      },
    });

    if (response.status === 200) {
      return {
        data: response.data.data,
        meta: response.data.meta,
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error:", error);
  }
  return { data: null, meta: null, status: 500 };
};

export const handleGetBlogBySlug = async (
  slug: string
): Promise<{
  data: BlogType | null;
  status: number;
}> => {
  try {
    const response = await axiosApi.get(`/john-blogs`, {
      params: {
        "filters[slug][$eq]": slug,
        populate: "*",
      },
    });

    if (response.status === 200) {
      return { data: response.data.data[0], status: response.status };
    }
  } catch (error) {
    console.error("Error:", error);
  }
  return { data: null, status: 500 };
};
